import { tailwindToCSS } from "tw-to-css";

import tailwindConfig from "../tailwind.config";

// Wrapper function
const twToCss = (classes: string) => {
	const { twi } = tailwindToCSS({
		config: {
			theme: tailwindConfig.theme
		}
	});

	return twi(classes);
};

export default twToCss;
